import { Observer, observer } from 'mobx-react-lite'
import { TextField, type TextFieldProps } from '@/components/inputs/TextField'
import { bindInput } from '@/infra/view-binding'
import type { FilterProps } from '@/infra/type-utils'
import {
  type ContainerProps,
  FormFieldContainer,
} from '@/components/FormContainer'

/**
 * Form field container for a {@link TextField}.
 */
export const TextFieldContainer = observer(function TextFieldContainer<
  M extends object,
  K extends keyof FilterProps<M, string>,
>({
  name,
  model,
  label,
  hint,
  field,
  error,
  hintTestId,
  'aria-label': ariaLabel,
  ...rest
}: ContainerProps<M, string, K, Omit<TextFieldProps, 'value'>>) {
  return (
    <FormFieldContainer
      name={name}
      model={model}
      label={label}
      hint={hint}
      field={field}
      error={error}
      aria-label={ariaLabel}
      hintTestId={hintTestId}
      render={(controlProps) => (
        // Using `Observer` here makes it so only the `TextField`
        // re-renders when the value changes.
        <Observer>
          {() => (
            <TextField
              {...controlProps}
              {...bindInput(model, field)}
              {...rest}
            />
          )}
        </Observer>
      )}
    />
  )
})
